import type { HtmlAttributes } from '@studio/design-system/props';
import type { Model } from '@studio/models/device';

/** Driver development status. */
export enum DriverStatus {
  BETA = 'beta'
}

/** Driver status badge properties. */
export type DriverStatusBadgeProps = HtmlAttributes<{
  /** Driver status. */
  status: DriverStatus;
}>;

/** Driver status mapping for models. */
export type DriverStatusMap = Record<Model['id'], DriverStatus>;
